<div class="saved-container">
  <!-- ! Header -->
  <div class="col-page-header-container">
    <div class="col-page-header-left">
      <ddc-button-n-one
        class="saved-import-btn"
        [_dynamicRoute]="'/saved'"
        [_hasBorder]="true"
        [_icon]="'arrow_forward'"
        [_label]="'Back to Collections'"
      ></ddc-button-n-one>
      <ddc-text-gradient
        class="text-xl col-page-title"
        [_icon]="'collections_bookmark'"
        [_text]="_collectionTitle"
        [_type]="'1'"
      ></ddc-text-gradient>
    </div>
    <div class="col-page-header-right">
      @if (!_allItemsMode) {
        <ddc-icon-function
          [icon]="'edit'"
          [tooltip]="'Edit Collection'"
          (click)="openEditCollectionDialog()"
        ></ddc-icon-function>
        <ddc-icon-function
          [icon]="'delete'"
          [tooltip]="'Delete Collection'"
          (click)="openDeleteCollectionDialog()"
        ></ddc-icon-function>
      }
    </div>
  </div>
  <mat-divider style="margin-bottom: 10px; margin-top: 10px"></mat-divider>
  <!-- ! Items -->
  <div class="elems-base-container">
    @if (!_isElemsLoading) {
      <div class="elems-container">
        <!-- ! Item types -->
        <div
          infiniteScroll
          [infiniteScrollDistance]="2"
          [infiniteScrollThrottle]="300"
          [scrollWindow]="true"
          (scrolled)="onElemsScroll()"
        >
          <div *ngFor="let elem of _elems; let i = index" style="margin: 10px">
            <!-- ! Word -->
            @if (elem.type == 'word') {
              <div>
                <ddc-content-card
                  [content]="elem"
                  (bookmarkChanged)="onBookmarkChanged($event, i)"
                  (clicked)="openReadWordDialog(elem)"
                  (deleteClicked)="openDeleteWordDialog(i)"
                  (editClicked)="openEditWordDialog(i)"
                ></ddc-content-card>
              </div>
            }
            <!-- ! Pair -->
            @if (elem.type == 'pair') {
              <div>
                <ddc-content-card
                  [content]="elem"
                  (bookmarkChanged)="onBookmarkChanged($event, i)"
                  (clicked)="openReadPairDialog(elem)"
                  (deleteClicked)="openDeletePairDialog(i)"
                  (editClicked)="openEditPairDialog(i)"
                ></ddc-content-card>
              </div>
            }
            <!-- ! Dic -->
            @if (elem.type == 'dictionary') {
              <div>
                <ddc-content-card
                  [content]="elem"
                  [dynamicRoute]="'/library/dic/' + elem.id + '/' + elem.owner.username"
                  [subscription]="_subscription"
                  (bookmarkChanged)="onBookmarkChanged($event, i)"
                  (deleteClicked)="openDeleteDicDialog(i)"
                ></ddc-content-card>
              </div>
            }
            <!-- ! Note -->
            @if (elem.type == 'note') {
              <div>
                <ddc-content-card
                  [content]="elem"
                  (bookmarkChanged)="onBookmarkChanged($event, i)"
                  (clicked)="openReadNoteDialog(elem)"
                  (deleteClicked)="openDeleteNoteDialog(i)"
                ></ddc-content-card>
              </div>
            }
            <!-- ! Quiz -->
            @if (elem.type == 'quiz') {
              <div>
                <ddc-content-card
                  [content]="elem"
                  (bookmarkChanged)="onBookmarkChanged($event, i)"
                  (clicked)="openReadQuizDialog(elem)"
                  (deleteClicked)="openDeleteQuizDialog(i)"
                ></ddc-content-card>
              </div>
            }
            <!-- ! Figure -->
            @if (elem.type == 'figure') {
              <div>
                <ddc-content-card
                  [content]="elem"
                  (bookmarkChanged)="onBookmarkChanged($event, i)"
                  (clicked)="openReadFigureDialog(elem)"
                  (deleteClicked)="openDeleteFigureDialog(i)"
                ></ddc-content-card>
              </div>
            }
          </div>
        </div>
        <!-- Info at bottom -->
        @if (_nElems > 0 && (!_elemsEnd || _elemsScrollLoading)) {
          <div class="elem-info-label">
            @if (!_elemsEnd && !_elemsScrollLoading) {
              <ng-lottie width="30px" [options]="scroll_options"></ng-lottie>
            }
            @if (_elemsScrollLoading) {
              <ng-lottie width="50px" [options]="loading_options"></ng-lottie>
            }
            @if (_elemsEnd && !_elemsScrollLoading) {
              <mat-icon>fact_check</mat-icon>
            }
            &nbsp;&nbsp;{{ _elemsPageInfoLabel }}
          </div>
        }
        <!-- No elems -->
        @if (_nElems === 0) {
          <ddc-not-available [_elem]="'Bookmark'"></ddc-not-available>
        }
      </div>
    }
  </div>
  @if (_isElemsLoading) {
    <div class="word-skeletons elem-skeletons">
      <ddc-loading-skeleton></ddc-loading-skeleton>
    </div>
  }
</div>
